import { useNavigate } from 'react-router-dom';
import PageNavbar from '../../components/feature/PageNavbar';

export default function EquipmentPage() {
  const navigate = useNavigate();

  const equipment = [
    {
      name: 'Amadeo',
      image: 'https://public.readdy.ai/ai/img_res/a24abecb5c748cd7b82e3be06793a2bf.jpg',
      link: '/equipment/amadeo'
    },
    {
      name: 'GRASP',
      image: 'https://readdy.ai/api/search-image?query=Interactive%20touchscreen%20rehabilitation%20table%20with%20colorful%20digital%20interface%20showing%20blue%20dots%20pattern%20female%20therapist%20guiding%20patient%20hand%20movements%20on%20screen%20modern%20therapy%20room%20bright%20lighting&width=400&height=280&seq=equip002&orientation=landscape',
      link: '/equipment/grasp'
    },
    {
      name: 'Exoskeleton',
      image: 'https://readdy.ai/api/search-image?query=Wearable%20leg%20exoskeleton%20rehabilitation%20device%20with%20black%20mechanical%20joints%20and%20straps%20attached%20to%20patient%20leg%20outdoor%20coastal%20setting%20with%20ocean%20background%20showing%20mobility%20assistance%20technology&width=400&height=280&seq=equip003&orientation=landscape',
      link: '/equipment/exoskeleton'
    },
    {
      name: 'Diego',
      image: 'https://readdy.ai/api/search-image?query=Upper%20body%20rehabilitation%20robot%20system%20with%20dual%20arm%20supports%20and%20suspension%20harness%20patient%20performing%20arm%20exercises%20with%20therapist%20assistance%20modern%20rehabilitation%20clinic%20professional%20medical%20equipment&width=400&height=280&seq=equip004&orientation=landscape',
      link: '/equipment/diego'
    },
    {
      name: 'Myro',
      image: 'https://readdy.ai/api/search-image?query=Interactive%20rehabilitation%20table%20with%20large%20touchscreen%20surface%20displaying%20colorful%20therapy%20games%20mobile%20wheeled%20design%20white%20frame%20modern%20medical%20equipment%20for%20cognitive%20and%20motor%20training&width=400&height=280&seq=equip005&orientation=landscape',
      link: '/equipment/myro'
    },
    {
      name: 'Pablo',
      image: 'https://readdy.ai/api/search-image?query=Handheld%20rehabilitation%20sensor%20device%20white%20ergonomic%20design%20patient%20gripping%20device%20for%20hand%20therapy%20and%20motor%20function%20assessment%20clinical%20setting%20close%20up%20view%20professional%20medical%20equipment&width=400&height=280&seq=equip006&orientation=landscape',
      link: '/equipment/pablo'
    },
    {
      name: 'Tymo',
      image: 'https://readdy.ai/api/search-image?query=Balance%20training%20platform%20with%20pressure%20sensors%20butterfly%20shaped%20design%20orange%20and%20gray%20colors%20digital%20display%20screen%20for%20balance%20assessment%20and%20rehabilitation%20exercises%20modern%20therapy%20equipment&width=400&height=280&seq=equip007&orientation=landscape',
      link: '/equipment/tymo'
    },
    {
      name: 'Tyrostation',
      image: 'https://readdy.ai/api/search-image?query=Complete%20rehabilitation%20workstation%20with%20adjustable%20desk%20dual%20monitors%20displaying%20therapy%20software%20ergonomic%20seating%20integrated%20sensor%20devices%20modern%20clinical%20setup%20professional%20medical%20equipment&width=400&height=280&seq=equip008&orientation=landscape',
      link: '/equipment/tyrostation'
    },
    {
      name: 'D-WALL',
      image: 'https://static.readdy.ai/image/c1d3a3065b1a0920ec31881e87c350dd/6c8c93bc86640057d7123be413af51d7.png',
      link: '/equipment/dwall'
    },
    {
      name: 'Tele Rehab for Remote Areas',
      image: 'https://readdy.ai/api/search-image?query=Portable%20telerehabilitation%20device%20compact%20white%20design%20with%20camera%20and%20sensors%20for%20remote%20therapy%20sessions%20home%20healthcare%20equipment%20modern%20telemedicine%20technology%20clean%20product%20photography&width=400&height=280&seq=equip010&orientation=landscape',
      link: '/equipment/telerehab'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <PageNavbar />

      {/* Equipment Grid */}
      <section className="py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {equipment.map((item, index) => (
              <div 
                key={index} 
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 group"
              >
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.name}</h3>
                <button
                  onClick={() => navigate(item.link)}
                  className="inline-flex items-center gap-1 text-teal-600 text-sm font-medium hover:text-teal-700 transition-colors mb-4 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line"></i>
                  Click for more information
                </button>
                <div className="rounded-xl overflow-hidden bg-gray-50">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-50 py-8 px-6 border-t border-gray-100 mt-8">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-gray-500 text-sm">
            © 2025 Accelerated Recovery Centre. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow noopener noreferrer"
            className="text-gray-400 text-xs hover:text-gray-600 transition-colors mt-2 inline-block"
          >
            Powered by Readdy
          </a>
        </div>
      </footer>
    </div>
  );
}
